import * as fns from 'date-fns'
import { WaitingScope } from 'src/components/waiting/waiting.scopes'
import { Observable, observe, Scope } from 'wdc-cube'
import {
    SerasaAuditCall,
    SerasaAuditStatistics,
    SerasaAvailableEndpoints,
    SerasaAvailableStatus
} from './serasa-history.types'

@Observable
export class HeaderScope extends Scope {}

@Observable
export class SerasaHistoryScope extends Scope {
    readonly header = new HeaderScope()

    @observe() waiting?: WaitingScope

    @observe() availableStatus = [] as SerasaAvailableStatus[]
    @observe() availableEndpoints = [] as SerasaAvailableEndpoints[]
    @observe() data = [] as SerasaAuditCall[]
    @observe() statusStatistics = [] as SerasaAuditStatistics[]
    @observe() urlStatistics = [] as SerasaAuditStatistics[]

    @observe() startDate = fns.subDays(new Date(), 30) as Date
    @observe() endDate = new Date()
    @observe() status = ''
    @observe() endpoint = ''

    onFind = Scope.ASYNC_ACTION_ONE<{ startDate?: Date; endDate?: Date; status?: string; endpoint?: string }>()
}

export default SerasaHistoryScope
